<template>
 <!-- HEADER-->
 <header id="header" class="header">
            <nav id="navbar" class="navbar fixed-top navbar-expand-lg navbar-dark bg-tra ">
                <div class="container">


                    <!-- LOGO IMAGE -->
                    <!-- For Retina Ready displays take a image with double the amount of pixels that your image will be displayed (e.g 260 x 60 pixels) -->
                    <RouterLink to="/" class="navbar-brand logo-white"><img src="@/assets/images/logo-grey.png" width="130" height="30" alt="header-logo"></RouterLink>
                    <RouterLink to="/" class="navbar-brand logo-black"><img src="@/assets/images/logo.png" width="130" height="30" alt="header-logo"></RouterLink>


                    <!-- Responsive Menu Button -->
                    <button class="navbar-toggler" type="button" data-toggle="collapse" data-target="#navbarSupportedContent" aria-controls="navbarSupportedContent" aria-expanded="false" aria-label="Toggle navigation">
                        <span class="navbar-toggler-icon"></span>
                    </button>


                    <!-- Navigation Menu -->
                    <div id="navbarSupportedContent" class="collapse navbar-collapse">
                        <ul class="navbar-nav ml-auto">

                            <!-- Dropdown Link -->

                            <li class="nav-item nl-simple"><RouterLink to="/" class="nav-link" >ACCUEIL</RouterLink></li>

                            <!-- Dropdown Link -->
                            <li class="nav-item dropdown">
                                <a class="nav-link dropdown-toggle" href="#" id="navbarDropdown" role="button" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                                    APAYM
                                </a>
                                <div class="dropdown-menu" aria-labelledby="navbarDropdown">
                                    <RouterLink class="dropdown-item" to="services">Nos services</RouterLink>							         	
                                    <RouterLink class="dropdown-item" to="nos-produits">Nos produits</RouterLink> 
                                    <RouterLink  class="dropdown-item" to="/tutos" >Astuces APAYM</RouterLink>                                                       
                                </div>
                            </li>
                          
                            <!-- Dropdown Link -->
                            <li class="nav-item dropdown">
                                <a class="nav-link dropdown-toggle" href="#" id="navbarDropdown" role="button" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                                    CARTES
                                </a>
                                <div class="dropdown-menu" aria-labelledby="navbarDropdown">
                                    <RouterLink to="nos-cartes" class="dropdown-item" >Nos cartes VISA</RouterLink> 
                                    <RouterLink to="tarifs" class="dropdown-item" >Tarifs</RouterLink>                                   
                                    <RouterLink to="privileges" class="dropdown-item">Privilèges</RouterLink>         	
                                    <RouterLink to="points-de-vente" class="dropdown-item" >Points de vente</RouterLink>
                                                    
                                </div>
                            </li>  
                            <li class="nav-item nl-simple"><RouterLink to="apaym-pro" class="nav-link" >APAYM PRO</RouterLink></li>  
                                                   

                            <!-- Dropdown Link -->
                            <li class="nav-item dropdown">
                                <a class="nav-link dropdown-toggle" href="#" id="navbarDropdown" role="button" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                                    A PROPOS
                                </a>
                                <div class="dropdown-menu" aria-labelledby="navbarDropdown">
                                    <RouterLink class="dropdown-item" to="qui-sommes-nous">Qui sommes nous</RouterLink> 
                                    <RouterLink class="dropdown-item" to="on-parle-de-nous">On parle de nous</RouterLink>                                   
                                    <RouterLink to="/nous-contacter" class="dropdown-item">Nous contacter</RouterLink>         	
                                    <RouterLink class="dropdown-item" to="faq">FAQs</RouterLink>
                                                  
                                </div>
                            </li>     
                          

                            <!-- Header Social Icons -->															
                            <li class="header-socials clearfix">
                                <span><a href="https://www.facebook.com/APaymApp" target="_blank" class="ico-facebook"><i class="fab fa-facebook-f"></i></a></span>
                                <span><a href="https://twitter.com/ApaymC" target="_blank" class="ico-twitter"><i class="fab fa-twitter"></i></a></span>                               
                                <span><a href="https://www.youtube.com/channel/UCvPjPcOiHUg_Ywg_mJJxaIw/featured?view_as=public" target="_blank" class="ico-youtube"><i class="fab fa-youtube"></i></a></span>

                                <!--<span><a href="#" class="ico-behance"><i class="fab fa-behance"></i></a></span>	-->
                            </li>

                        </ul>
                    </div>	<!-- End Navigation Menu -->


                </div>	  <!-- End container -->
            </nav>	   <!-- End navbar  -->
        </header>	
        <!-- END HEADER -->

</template>

<script>
import {RouterLink, useRouter} from "vue-router";
/* eslint-disable */
export default {

    name: "header_menu",
    components: {
        RouterLink,
        useRouter
    },
    data(){
        return{
        }
    },
    methods: {

        handleScroll (event) {
            let pixel = window.scrollY
            let nomRoute = this.$route.name
            let pathRoute = this.$route.path
            let stiqy = (pixel>50 && nomRoute === "home_view") ? navbar.classList.add("bgblue") : navbar.classList.remove("bgblue")

            console.log(this.$route.name );
                // console.log(event.srcElement.location.pathname);
            // let stiqy2 = (pixel>55 && event.srcElement.location.pathname !== "/") ? navbar.classList.add('bg-blanc') : navbar.classList.remove('bg-blanc')
            if (pixel > 50 && nomRoute !== "home_view") {
                console.log(window.scrollY);
                console.log(this.$route.name );
                navbar.classList.add("bgblanc");
            }
        }
    },

    created () {
        window.addEventListener('scroll', this.handleScroll);
    },

    beforeMount() {
    },

    mounted(){
    },

    unmounted () {
        window.removeEventListener('scroll', this.handleScroll);
    },

    watch: {
        // whenever question changes, this function will run
    },
}
</script>
